import React from "react";
import * as Mui from "@mui/material";
import { SvgIconProps } from "@mui/material/SvgIcon";

/**
 * Icons the Search Agent surfaces need that react-feather does not carry.
 * Everything else on this tab comes from react-feather like the rest of the app. The sparkle is
 * shared with the lead activity feed, so it lives in component/shared.
 */

export { SparkleIcon } from "component/shared/sparkle-icon";

export const BedIcon = (props: SvgIconProps) => (
	<Mui.SvgIcon viewBox="0 0 24 24" {...props}>
		<g fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
			<path d="M2 20v-8a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v8" />
			<path d="M4 10V6a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v4" />
			<path d="M12 4v6" />
			<path d="M2 18h20" />
		</g>
	</Mui.SvgIcon>
);

/** Lucide's user-pen. */
export const UserPenIcon = (props: SvgIconProps) => (
	<Mui.SvgIcon viewBox="0 0 24 24" {...props}>
		<g fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
			<path d="M11.5 15H7a4 4 0 0 0-4 4v2" />
			<path d="M21.378 16.626a1 1 0 0 0-3.004-3.004l-4.01 4.012a2 2 0 0 0-.506.854l-.837 2.87a.5.5 0 0 0 .62.62l2.87-.837a2 2 0 0 0 .854-.506z" />
			<circle cx="10" cy="7" r="4" />
		</g>
	</Mui.SvgIcon>
);

export const BathIcon =(props: SvgIconProps) => (
	<Mui.SvgIcon viewBox="0 0 24 24" {...props}>
		<g fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
			<path d="M10 4 8 6" />
			<path d="M17 19v2" />
			<path d="M2 12h20" />
			<path d="M7 19v2" />
			<path d="M9 5 7.621 3.621A2.121 2.121 0 0 0 4 5v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-5" />
		</g>
	</Mui.SvgIcon>
);
